module.exports = __webpack_public_path__ + "img/ico_live_broadcast.c4413707.svg";